import { apiInstance } from "@/api/api.js"
const api = apiInstance()

export default {
  async getStaticMedia({ state, commit, dispatch }) {
    if (state.staticMediaLoading) return

    commit('setStaticMediaLoading', true)
    const url = '/static-media'
    try {
      const response = await api.get(url)
      commit('setStaticMedia', response.data.content)
    } catch (error) {
      dispatch('appStates/setErrorMessage', error,{ root: true })
    } finally {
      commit('setStaticMediaLoading', false)
    }
  }
}
